import axios from 'axios';
import * as apiConstant from './apiConstant';

/****************************************
    Api for Blog
    @author  IMH003
    @date    2020.5.10
    @version 0.1    
 ******************************************/
class blogApi {
    
    static getBlogsWithPage(page, business, subCate, searchKey, order, isHome, perpage) {
        var lang_key = localStorage.getItem('language');
        var urlMe = `${apiConstant.API_URL}/blog/paginate/${(lang_key === undefined || lang_key === null)? 'en' : lang_key}?business=${business}&page=${page}&sub=${subCate}&order=${order}&isHome=${isHome}&perpage=${perpage}`;
        urlMe += searchKey.length === 0 ? '' : `&search=${searchKey}`;        
        return axios({
            url : urlMe,
            method: 'GET',
            headers: {
                'accept': 'application/json'
            }
        })
        .then(function (response) {              
            return response;
        })
        .catch(function (error) {
            console.log("Get Blogs error==", error);
            return error;
        });
    }

    static getBlogsAll(business, subCate, searchKey, isHome, order) {
        var lang_key = localStorage.getItem('language');
        var urlMe = `${apiConstant.API_URL}/blog/all/${(lang_key === undefined || lang_key === null)? 'en' : lang_key}?business=${business}&isHome=${isHome}&order=${order}`;
        urlMe += searchKey.length === 0 ? '' : `&search=${searchKey}`;
        return axios({
            url : urlMe,
            method: 'GET',
            headers: {
                'accept': 'application/json'
            }
        })
        .then(function (response) {              
            return response;
        })
        .catch(function (error) {
            console.log("Get Blogs error==", error);
            return error;
        });
    }

    static getSideBlogs(targetId, targetBusiness) {
        var lang_key = localStorage.getItem('language');
        var urlMe = `${apiConstant.API_URL}/blog/others/${(lang_key === undefined || lang_key === null)? 'en' : lang_key}?t=${targetId}&tb=${targetBusiness}&business=${targetBusiness}`;        
        
        return axios({
            url : urlMe,
            method: 'GET',
            headers: {
                'accept': 'application/json'
            }
        })
        .then(function (response) { 
            return response;
        })
        .catch(function (error) {
            console.log("Get Blogs error==", error);
            return error;
        });
    }

    static getBlog(business, id) {
        var lang_key = localStorage.getItem('language');
        var urlMe = `${apiConstant.API_URL}/${business}/${(lang_key === undefined || lang_key === null)? 'en' : lang_key}/${id}`;
        return axios({
            url : urlMe,
            method: 'GET',
            headers: {
                'accept': 'application/json'
            }
        })
        .then(function (response) {              
            return response;
        })
        .catch(function (error) {
            console.log("Get Blogs error==", error);
            return error;
        });
    }

    static getBlogTitle(business, id) {
        var lang_key = localStorage.getItem('language');
        return axios({
            url : `${apiConstant.API_URL}/${business}/title/${(lang_key === undefined || lang_key === null)? 'en' : lang_key}/${id}`,
            method: 'GET',
            headers: {
                'accept': 'application/json'
            }
        })
        .then(function (response) {              
            return response;
        })
        .catch(function (error) {
            console.log("Get Blogs error==", error);
            return error;
        });
    }

    static getCategories() {
        var lang_key = localStorage.getItem('language');
        return axios({
            url : `${apiConstant.API_URL}/blog/category/${(lang_key === undefined || lang_key === null)? 'en' : lang_key}`,
            method: 'GET',
            headers: {
                'accept': 'application/json'
            }
        })
        .then(function (response) {  
            return response;
        })
        .catch(function (error) {
            console.log("Get Blogs error==", error);
            return error;
        });
    }

    static getArticles(isHome) {
        var lang_key = localStorage.getItem('language');
        var urlMe = `${apiConstant.API_URL}/article/all/${(lang_key === undefined || lang_key === null)? 'en' : lang_key}?isHome=${isHome}`;
        return axios({
            url : urlMe,
            method: 'GET',
            headers: {
                'accept': 'application/json'
            }
        })
        .then(function (response) {              
            return response;
        })
        .catch(function (error) {
            console.log("Get Blogs error==", error);
            return error;
        });
    }
}

export default blogApi;